import React from 'react';
import Tooltip from '../tooltip/Tooltip';
import './Checkbox.css';

const Checkbox = ({ checkboxValue, checkboxName, checkboxStatus, checkboxFunction, checkboxId, checkboxEnable, tooltip, tooltipTag, nameCheck }) => {
  return (
    <div className="no-maxWidth">
      <div className="customCheck">
        <label htmlFor={checkboxId}>
          <input
            type="checkbox"
            value={checkboxValue}
            checked={checkboxStatus}
            onChange={checkboxFunction}
            className="segurosCheckBox"
            disabled={checkboxEnable ? "disabled":null}
            name={nameCheck}
          />
          <span className="icon" />
          <p>
            {checkboxName}
          </p>
        </label>
        {tooltip &&  <Tooltip message={tooltip} tag={tooltipTag} />}
      </div>
    </div>
  );
}

export default Checkbox;